import { createRouter, createWebHistory } from 'vue-router';
import AppStaffStat from '@/components/AppStaffStat.vue';
import AppStaffAvance from '@/components/AppStaffAvance.vue';
import AppPlanning from '@/components/AppPlanning.vue';
import AppMainBar from '@/components/AppMainBar.vue';
import AppStaffRemarques from '@/components/AppStaffRemarques.vue';
import AppLogin from '@/components/AppLogin.vue';
import AppSalaryMass from '@/components/AppSalaryMass.vue';
import AppDashStat from '@/components/AppDashStat.vue';
import AppProfile from '@/components/AppProfile.vue';
import AppCurrentlyWorking from '@/components/AppCurrentlyWorking.vue';
import AppDailySummary from '@/components/AppDailySummary.vue';
import AppEmployeeDossier from '@/components/AppEmployeeDossier.vue';
import AppNotifications from '@/components/AppNotifications.vue';
import AppCashierAdvance from '@/components/AppCashierAdvance.vue';
import AppEmployeeAdvances from '@/components/AppEmployeeAdvances.vue';
import AppScheduleCompliance from '@/components/AppScheduleCompliance.vue';


const getSessionRole = () => {
  const match = document.cookie.match(new RegExp('(?:^|; )session_id=([^;]*)'));
  if (!match) return null;
  const session = decodeURIComponent(match[1]);
  return session.includes('55') ? session.split('55')[0] : session;
};

const routes = [
  {
    path: '/',
    name: 'dashstats',
    component: AppDashStat, // This route leads to the login page
    meta: { roles: ['admin'] },
  },
  {
    path: '/cashier',
    name: 'cashierAdvance',
    component: AppCashierAdvance,
    meta: { roles: ['caissier'] },
  },
  {
    path: '/mes-avances',
    name: 'employeeAdvances',
    component: AppEmployeeAdvances,
    meta: { roles: ['employe'] },
  },
  {
    path: '/masse-salarial',
    name: 'salarymass',
    component: AppSalaryMass, // This route leads to the login page
    meta: { roles: ['admin'] },
  },
  {
    path: '/login',
    name: 'login',
    component: AppLogin, // This route leads to the login page
  },
  {
    path: '/pointage', // Dynamic path for staffId
    name: 'ClockData',
    component: AppStaffStat,
    props: true,  // Allow the route parameter to be passed as a prop to the component
    meta: { roles: ['admin'] },
  },
  {
    path: '/avances', // Dynamic path for staffId
    name: 'avances',
    component: AppStaffAvance,
    props: true,  // Allow the route parameter to be passed as a prop to the component
    meta: { roles: ['admin'] },
  },
  {
    path: '/remarques', // Dynamic path for staffId
    name: 'remarques',
    component: AppStaffRemarques,
    props: true,  // Allow the route parameter to be passed as a prop to the component
    meta: { roles: ['admin'] },
  },
  {
    path: '/planning',
    name: 'planning',
    component: AppPlanning,
    props: true,
    meta: { roles: ['admin'] },
  },
  {
    path: '/dossiers',
    name: 'dossiers',
    component: AppEmployeeDossier,
    meta: { roles: ['admin'] },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: AppNotifications,
    meta: { roles: ['admin'] },
  },
  {
    path: '/respect-horaires',
    name: 'scheduleCompliance',
    component: AppScheduleCompliance,
    meta: { roles: ['admin'] },
  },
  {
    path: '/repos',
    redirect: '/planning',
  },
  {
    path: '/encours', // Currently working employees
    name: 'encours',
    component: AppCurrentlyWorking,
    props: true,  // Allow the route parameter to be passed as a prop to the component
    meta: { roles: ['admin'] },
  },
  {
    path: '/journee',
    name: 'dailySummary',
    component: AppDailySummary,
    meta: { roles: ['admin'] },
  },
  {
    path: '/main/:selected', // Dynamic path for staffId
    name: 'main',
    component: AppMainBar,
    props: true,  // Allow the route parameter to be passed as a prop to the component
    meta: { roles: ['admin'] },
  },
  {
    path: '/myprofile', // Dynamic path for staffId
    name: 'myprofile',
    component: AppProfile,
    meta: { roles: ['admin', 'caissier', 'employe'] },
  },
  // Add more routes if needed
];

const router = createRouter({
  history: createWebHistory('/pointage'),  // Use HTML5 History Mode
  routes,
});


// Navigation Guard to check if user is authenticated before accessing protected routes
router.beforeEach((to, _, next) => {
  const role = getSessionRole();
  const homeByRole = {
    admin: '/',
    caissier: '/cashier',
    employe: '/mes-avances',
  };
  if (!role) {
    // user مازال ما logged
    if (to.path === "/login") {
      next();
    } else {
      next("/login");
    }
  } else {
    const allowed = to.meta?.roles;
    if (allowed && !allowed.includes(role)) {
      next(homeByRole[role] || '/login');
      return;
    }
    // user logged
    if (to.path === "/login") {
      next(homeByRole[role] || "/");
    } else {
      next();
    }
  }
});

export default router;
